import Icon from '../components/Icon.vue'

Icon.register({
  'folder-plus': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 128c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h160l64 64h192zM368 296v-16c0-8.8-7.2-16-16-16h-72v-72c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v72h-72c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h72v72c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-72h72c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/folder-plus.js
// module id = 1365
// module chunks = 0